import {
  ADD_ONBOARDING_FIELD_ERROR,
  ADD_ONBOARDING_FIELDS_ERRORS,
  CHANGE_ONBOARDING_FORM_FIELD,
  CLEAR_ONBOARDING_FIELD_ERROR,
  RESET_ONBOARDING_FORM_DATA,
} from './actions'

export const defaultFormData = () => ({
  emotionWords: [],
  subjects: [],
  grades: [],
})

interface OnboardingState {
  formData: ReturnType<typeof defaultFormData>
  errors: Record<string, string | undefined>
}

export const initialState = (): OnboardingState => ({
  formData: defaultFormData(),
  errors: {},
})

type Action =
  | { type: typeof CHANGE_ONBOARDING_FORM_FIELD; payload: { key: string; value: unknown } }
  | { type: typeof ADD_ONBOARDING_FIELD_ERROR; payload: { field: string; error: string } }
  | { type: typeof ADD_ONBOARDING_FIELDS_ERRORS; payload: { errors: Record<string, unknown> } }
  | { type: typeof CLEAR_ONBOARDING_FIELD_ERROR; payload: { field: string } }
  | { type: typeof RESET_ONBOARDING_FORM_DATA }

export default function root(
  state: OnboardingState = initialState(),
  action: Action,
): OnboardingState {
  switch (action.type) {
    case CHANGE_ONBOARDING_FORM_FIELD:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.key]: action.payload.value,
        },
      }

    case ADD_ONBOARDING_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: action.payload.error,
        },
      }

    case ADD_ONBOARDING_FIELDS_ERRORS:
      return {
        ...state,
        errors: action.payload.errors as Record<string, string | undefined>,
      }

    case CLEAR_ONBOARDING_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: undefined,
        },
      }

    case RESET_ONBOARDING_FORM_DATA:
      return {
        ...state,
        formData: defaultFormData(),
        errors: {},
      }

    default:
      return state
  }
}
